import { Box } from "@mui/system";
import React, { useRef } from "react";
import style from "./FormComoponent.module.css";
import CustomizedTabel from "./CustomizedTabel";
import DiffrenceTable from "./DiffrenceTable";
import {
  StandardRowDataOne,
  StandardRowDataTwo,
  colDataComplaint,
  colDataComplaintOther,
  colDataMPHA,
  rowData,
  rowData2,
  rowData3,
  rowData4,
  rowData5,
  rowData6,
  rowData7,
  rowData8,
} from "../../constants/fmrForm";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const FMRFormComponent = () => {
  const reportTemplateRef = useRef(new Array());
  const handleGeneratePdf = async () => {
    const doc = new jsPDF({
      format: "a1",
      unit: "px",
      orientation: "p",
      putOnlyUsedFonts: true,
    });
    const pages = reportTemplateRef?.current;
    // Adding the fonts
    doc.setFont("Inter-Regular", "normal");

    for (let i = 0; i < pages.length; i++) {
      if (i !== 0) {
        doc.addPage();
      }
      let page = pages[i];
      const canvas = await html2canvas(page, { scale: 1.5 });
      const imgData = canvas.toDataURL("image/png");

      doc.addImage(
        imgData,
        "PNG",
        0,
        10,
        canvas.width * 0.7,
        canvas.height * 0.7
      );
    }

    doc.save("document");

    // doc.html(reportTemplateRef.current, {
    //   async callback(doc) {
    //     await doc.save("document");
    //   },
    // });
  };

  return (
    <div>
      <button onClick={handleGeneratePdf}>Download PDF</button>
      <Box sx={{ border: "1px solid black" }}>
        <Box ref={(e) => reportTemplateRef?.current?.push(e)}>
          <h1 className={style["right-align-title"]}>FMR1</h1>
          <h1 className={style["center-text-title"]}>
            Fraud Monitoring Report
          </h1>
          <div className={style["div-with-two-h1"]}>
            <h1>Name of the Insure: HDFC General Insurance Company Ltd</h1>
            <h1>
              Report for the Quarter Ending: Q4 FY 22 (Till 31<sup>st</sup>{" "}
              March 2022 )
            </h1>
          </div>
          <h1 className={style["center-text-title"]}>Part 1</h1>
          <h1 className={style["heading-part-one"]}>
            Fraud Oustanding - Business Segment wise for Q4 FY 22 (Till 31
            <sup>st</sup> March 2022 )
          </h1>
          <h1 className={style["subHeading-part-one"]}>
            Claims related frauds
          </h1>
          <div className={style["div-flex-content"]}>
            <h1>Motor (Theft)</h1>
            <h1>(Amt in Lakhs)</h1>
          </div>

          <CustomizedTabel rowData={rowData} />

          <div style={{ height: "50px" }}></div>
          <div className={style["div-flex-content"]}>
            <h1>Motor (Own Damage):</h1>
            <h1>(Amt in Lakhs)</h1>
          </div>
          <CustomizedTabel rowData={rowData2} />
        </Box>

        <Box ref={(e) => reportTemplateRef?.current?.push(e)}>
          <div style={{ height: "50px" }}></div>
          <div className={style["div-flex-content"]}>
            <h1>Motor (Third Party):</h1>
            <h1>(Amt in Lakhs)</h1>
          </div>

          <CustomizedTabel rowData={rowData3} />
          <div className={style["div-motor-content"]}>
            <p className={style["p-tag-motor"]}>
              * Verdict of MACT in ----- cases are pending and therefore have
              been shown as unresolved. Based on verdict, description of fraud
              may change subsequently.
            </p>
            <h1>
              (-cases of FY 13, -- cases of FY 14, --- cases of FY 15, --- cases
              of FY 16, --- cases of FY 17, --- cases of FY 18, --- cases of FY
              19, --- cases of FY 20, ---- cases of FY 21 & ---cases of FY 22)
            </h1>
          </div>
          <div style={{ height: "30px" }}></div>
          <div className={style["div-flex-content"]}>
            <h1>Property:</h1>
            <h1>(Amt in Lakhs)</h1>
          </div>
          <CustomizedTabel rowData={rowData4} />
          <p className={style["p-tag"]}>
            * -- cases of Q3 are pending trial in the court/s
          </p>
        </Box>

        <Box ref={(e) => reportTemplateRef?.current?.push(e)}>
          <div style={{ height: "30px" }}></div>
          <div className={style["div-flex-content"]}>
            <h1>Health & PA:</h1>
            <h1>(Amt in Lakhs)</h1>
          </div>
          <CustomizedTabel rowData={rowData5} />

          <div style={{ height: "30px" }}></div>
          <h1 className={style["div-flex-content-c"]}>Others</h1>
          <div className={style["div-flex-content"]}>
            <h1>Category – Complaints</h1>
            <h1>(Amt in Lakhs)</h1>
          </div>
          <CustomizedTabel rowData={rowData6} />
          <div className={style["div-motor-content"]}>
            <p className={style["p-tag-motor"]}>
              # Out of -- cases; --cases are of Q3 FY 22 [Disciplinary action
              Pending in --- cases & Police Complaint pending in -- case]. In
              remaining --- cases, Filing of Police complaint pending in --cases
              and -- cases are pending for disciplinary action.
            </p>
          </div>
        </Box>

        <Box ref={(e) => reportTemplateRef?.current?.push(e)}>
          <div style={{ height: "30px" }}></div>
          <div className={style["div-flex-content"]}>
            <h1>Category – Whistleblower</h1>
            <h1>(Amt in Lakhs)</h1>
          </div>
          <CustomizedTabel rowData={rowData7} />
          <h1 className={style["center-text-title"]}>Part II</h1>
          <h1 className={style["heading-part-one"]}>
            Statistical details: (Unresolved cases as at the end of Q4 FY 22
            (Till 31
            <sup>st</sup> March 2022 )
          </h1>
          <h1 className={style["subHeading-part-one"]}>
            Claims related frauds
          </h1>
          <div className={style["div-flex-content-M"]}>
            <h1>Motor, Property, Health & Accident:</h1>
            <h1>(Amt in Lakhs)</h1>
          </div>
          <CustomizedTabel
            variant="Standard"
            StandardRowData={StandardRowDataOne}
          />
          <div style={{ height: "30px" }}></div>
          <h1 className={style["subHeading-part-one"]}>Others:</h1>
          <div className={style["div-flex-content"]}>
            <h1>Category – Complaints</h1>
            <h1>(Amt in Lakhs)</h1>
          </div>
          <CustomizedTabel
            variant="Standard"
            StandardRowData={StandardRowDataTwo}
          />
        </Box>

        <Box ref={(e) => reportTemplateRef?.current?.push(e)}>
          <h1 className={style["center-text-title"]}>Part III</h1>
          <h1 className={style["heading-part-one"]}>
            Statistical details: (Preventive / Corrective steps taken during Q4
            FY 22 (Till 31
            <sup>st</sup> March 2022 )
          </h1>
          <h1 className={style["subHeading-part-one"]}>
            Claims related frauds
          </h1>
          <div className={style["div-flex-content-M"]}>
            <h1>Motor, Property, Health & Accident:</h1>
            <h1>(Amt in Lakhs)</h1>
          </div>
          <DiffrenceTable colData={colDataMPHA} />
          <h1 className={style["subHeading-part-one"]}>Others</h1>
          <h1 className={style["heading-part-one"]}>Complaints:</h1>
          <DiffrenceTable colData={colDataComplaint} />
        </Box>

        <Box ref={(e) => reportTemplateRef?.current?.push(e)}>
          <DiffrenceTable colData={colDataComplaintOther} />
          <h1 className={style["center-text-title"]}>Part IV</h1>
          <h1 className={style["h1-without-underline"]}>
            Cases Reported to Law Enforcement Agencies during Q4 FY 22 (Till
            31st March 2022)
          </h1>
          <h1 className={style["right-align-amount"]}> (Amt in Lakhs)</h1>
          <CustomizedTabel rowData={rowData8} />
          <h1 className={style["star-content"]}>****</h1>
        </Box>
      </Box>
    </div>
  );
};

export default FMRFormComponent;
